<template>
  <div v-title :data-title="$route.name">
    <!-- PC端 -->
    <div v-if="offsetwidth > 850" class="pc-container">
      <!-- Banner区域 -->
      <div class="banner-wrapper">
        <img class="banner-img" src="../assets/Battertimg/PC/contacttop.jpg" alt="" />
        <div class="banner-title">Contact us</div>
        
        <!-- 三个联系方式卡片 -->
        <div class="contact-cards">
          <div class="contact-card">
            <div class="card-icon">
              <img src="../assets/Battertimg/PC/phoneicon.png" alt="" />
            </div>
            <div class="card-label">Phone</div>
            <div class="card-value">(04) 5245 7579</div>
          </div>
          <div class="contact-card">
            <div class="card-icon">
              <img src="../assets/Battertimg/PC/emailicon.png" alt="" />
            </div>
            <div class="card-label">E-mail</div>
            <div class="card-value">info@batteryplant.com.au</div>
          </div>
          <div class="contact-card">
            <div class="card-icon">
              <img src="../assets/Battertimg/PC/addressicon.png" alt="" />
            </div>
            <div class="card-label">Head Office Address</div>
            <div class="card-value">203 Blackburn Rd Mount Waverley VIC 3149</div>
          </div>
        </div>
      </div>

      <!-- 表单区域 -->
      <div class="form-wrapper">
        <div class="form-header">Get Your Free Residential Solar & Battery Quote</div>
        <div class="form-subtitle">Fill out the form below and our team will contact you shortly.</div>
        
        <div class="form-container">
          <el-form ref="form" :model="form" label-width="120px" label-position="top" :rules="rules">
            <div class="form-row">
              <el-form-item label="First Name" prop="FirstName" class="form-item-half">
                <el-input v-model="form.FirstName" placeholder="First Name*" clearable />
              </el-form-item>
              <el-form-item label="Last Name" prop="LastName" class="form-item-half">
                <el-input v-model="form.LastName" placeholder="Last Name*" clearable />
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item label="Phone" prop="Phone" class="form-item-half">
                <el-input v-model="form.Phone" placeholder="Phone*" clearable />
              </el-form-item>
              <el-form-item label="E-mail" prop="Email" class="form-item-half">
                <el-input v-model="form.Email" placeholder="E-mail" clearable />
              </el-form-item>
            </div>

            <div class="form-row">
              <el-form-item label="Address / Postcode" prop="Address" class="form-item-full">
                <el-input 
                  v-model="form.Address" 
                  placeholder="Installation Address/Postcode*" 
                  @focus="geolocate()"
                  id="autocompletepc"
                  clearable 
                />
              </el-form-item>
            </div>

            <div class="form-row">
              <div class="form-item-half">
                <el-form-item label="Interested In:" prop="InterestedGroup">
                  <el-radio-group v-model="form.InterestedGroup">
                    <el-radio label="Solar">Solar</el-radio>
                    <el-radio label="Battery">Battery</el-radio>
                    <el-radio label="Solar+Battery">Solar+Battery</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div class="form-item-half">
                <el-form-item label="Enquiry Type" prop="EnquiryType">
                  <el-select v-model="form.EnquiryType" placeholder="Please Select" clearable>
                    <el-option v-for="item in options" :key="item.Id" :label="item.Name" :value="item.Id" />
                  </el-select>
                </el-form-item>
              </div>
            </div>

            <div class="form-submit">
              <el-button type="primary" @click="submitForm" class="submit-btn" :disabled="isSubmitting">
                Submit
              </el-button>
            </div>
          </el-form>
        </div>
      </div>

      <!-- FAQ区域 -->
      <div class="faq-wrapper">
        <div class="faq-title">FAQ</div>
        <div class="faq-item">
          <div class="faq-question">Q: How much can l save with solar?</div>
          <div class="faq-answer">A: Savings depend on your electricity usage and system size, but many households significantly reduce their power bills after installation - apply this.</div>
        </div>
        <div class="faq-item">
          <div class="faq-question">Q: ls battery storage safe?</div>
          <div class="faq-answer">A: Yes. We install approved battery systems and follow strict safety standards.</div>
        </div>
        <div class="faq-item">
          <div class="faq-question">Q: How long does installation take?</div>
          <div class="faq-answer">A: Most residential systems can be installed within a Day or two.</div>
        </div>
      </div>

      <!-- 底部导航 -->
      <footer class="footer">
        <div class="footer-top">
          <div class="footer-logo">
            <img src="../assets/Battertimg/PC/Batteryplantlogo.png" alt="" />
          </div>
          <div class="footer-nav">
            <span @click="goto('HOME')">HOME</span>
            <span @click="goto('PROJECT')">ABOUT US</span>
            <span @click="goto('PRODUCTS')">PRODUCTS</span>
            <span @click="goto('CASE')">GALLERY</span>
            <span @click="goto('CONTACTUS')">CONTACT US</span>
            <span @click="goto('CONTACTUS')">BOOK NOW</span>
          </div>
        </div>
        <div class="footer-divider"></div>
        <div class="footer-contact">
          <div>(04) 5245 7579</div>
          <div>info@batteryplant.com.au</div>
          <div>203 Blackburn Rd Mount Waverley VIC 3149</div>
        </div>
      </footer>
    </div>

    <!-- 移动端 -->
    <div v-else class="mobile-container">
      <!-- Banner区域 -->
      <div class="mobile-banner">
        <img class="mobile-banner-img" src="../assets/Battertimg/H5/contacttop.jpg" alt="" />
        <div class="mobile-banner-title">Contact Us</div>
        
        <!-- 移动端三个白框 -->
        <div class="mobile-contact-cards">
          <div class="mobile-contact-card">
            <img src="../assets/Battertimg/PC/phoneicon.png" alt="" />
            <div class="card-label">Phone</div>
            <div class="card-value">(04) 5245 7579</div>
          </div>
          <div class="mobile-contact-card">
            <img src="../assets/Battertimg/PC/emailicon.png" alt="" />
            <div class="card-label">E-mail</div>
            <div class="card-value">info@batteryplant.com.au</div>
          </div>
          <div class="mobile-contact-card">
            <img src="../assets/Battertimg/PC/addressicon.png" alt="" />
            <div class="card-label">Head Office Address</div>
            <div class="card-value">203 Blackburn Rd Mount Waverley VIC 3149</div>
          </div>
        </div>
      </div>

      <!-- 移动端表单 -->
      <div class="mobile-form-wrapper">
        <div class="mobile-form-header">Get Your Free Residential Solar & Battery Quote</div>
        <div class="mobile-form-subtitle">Fill out the form below and our team will contact you shortly.</div>
        
        <div class="mobile-form-container">
          <el-form ref="form" :model="form" label-width="120px" label-position="top" :rules="rules">
            <el-form-item label="First Name" prop="FirstName">
              <el-input v-model="form.FirstName" placeholder="First Name*" clearable />
            </el-form-item>
            <el-form-item label="Last Name" prop="LastName">
              <el-input v-model="form.LastName" placeholder="Last Name*" clearable />
            </el-form-item>
            <el-form-item label="Phone" prop="Phone">
              <el-input v-model="form.Phone" placeholder="Phone*" clearable />
            </el-form-item>
            <el-form-item label="Address/Postcode" prop="Address">
              <el-input 
                v-model="form.Address" 
                placeholder="Installation Address/Postcode*" 
                @focus="geolocate()"
                id="autocompleteh5"
                clearable 
              />
            </el-form-item>
            <el-form-item label="E-mail" prop="Email">
              <el-input v-model="form.Email" placeholder="E-mail" clearable />
            </el-form-item>
            <el-form-item label="Interested In:" prop="InterestedGroup">
              <el-radio-group v-model="form.InterestedGroup">
                <el-radio label="Solar">Solar</el-radio>
                <el-radio label="Battery">Battery</el-radio>
                <el-radio label="Solar+Battery">Solar+Battery</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="Enquiry Type" prop="EnquiryType">
              <el-select v-model="form.EnquiryType" placeholder="Please Select" clearable>
                <el-option v-for="item in options" :key="item.Id" :label="item.Name" :value="item.Id" />
              </el-select>
            </el-form-item>
            <div class="mobile-submit">
              <el-button type="primary" @click="submitForm" class="submit-btn" :disabled="isSubmitting">
                Submit
              </el-button>
            </div>
          </el-form>
        </div>
      </div>

      <!-- 移动端FAQ -->
      <div class="mobile-faq-wrapper">
        <div class="faq-title">FAQ</div>
        <div class="faq-item">
          <div class="faq-question">Q: How much can l save with solar?</div>
          <div class="faq-answer">A: Savings depend on your electricity usage and system size, but many households significantly reduce their power bills after installation - apply this.</div>
        </div>
        <div class="faq-item">
          <div class="faq-question">Q: ls battery storage safe?</div>
          <div class="faq-answer">A: Yes. We install approved battery systems and follow strict safety standards.</div>
        </div>
        <div class="faq-item">
          <div class="faq-question">Q: How long does installation take?</div>
          <div class="faq-answer">A: Most residential systems can be installed within a Day or two.</div>
        </div>
      </div>

      <!-- 移动端底部导航 -->
      <footer class="mobile-footer">
        <div class="mobile-footer-logo">
          <img src="../assets/Battertimg/PC/Batteryplantlogo.png" alt="" />
        </div>
        <div class="mobile-footer-nav">
          <span @click="goto('HOME')">HOME</span>
          <span @click="goto('PROJECT')">ABOUT US</span>
          <span @click="goto('PRODUCTS')">PRODUCTS</span>
          <span @click="goto('CASE')">GALLERY</span>
          <span @click="goto('CONTACTUS')">CONTACT US</span>
          <span @click="goto('CONTACTUS')">BOOK NOW</span>
        </div>
        <div class="footer-divider"></div>
        <div class="mobile-footer-contact">
          <div>(04) 5245 7579</div>
          <div>info@batteryplant.com.au</div>
          <div>203 Blackburn Rd Mount Waverley VIC 3149</div>
        </div>
      </footer>
    </div>

    <!-- Google Maps组件 -->
    <GMaps v-show="false" ref="child" :offsetwidth="offsetwidth" :map-data="mapData" @fun="getinfo" />
  </div>
</template>

<script>
import GMaps from "../H5/map/Gmaps.vue";
import { get, post } from "../assets/api/api";
import { OrdersIntentionDown, ContactUsSubmit } from "../assets/api/request.js";

export default {
  components: { GMaps },
  props: { offsetwidth: { type: Number } },
  data() {
    return {
      isSubmitting: false,
      options: [],
      mapData: { latitude: 33.242, longitude: 124.12 },
      form: {
        FirstName: "", LastName: "", Address: "", Phone: "", Email: "",
        EnquiryType: "", InterestedGroup: "", Message: "",
        Suburb: "", Postcode: "", streetName: "", Street_number: "", City: "",
      },
      rules: {
        FirstName: [{ required: true, message: "First Name is required", trigger: ["change", "blur"] }],
        LastName: [{ required: true, message: "Last Name is required", trigger: ["change", "blur"] }],
        Address: [{ required: true, message: "Address is required", trigger: ["change", "blur"] }],
        EnquiryType: [{ required: true, message: "Enquiry Type is required", trigger: ["change", "blur"] }],
        InterestedGroup: [{ required: true, message: "Interested In is required", trigger: ["change", "blur"] }],
        Email: [{ pattern: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/, message: "Email format is incorrect", trigger: ["change", "blur"] }],
        Phone: [
          { required: true, message: "Phone is required", trigger: ["change", "blur"] },
          { pattern: /^[0][3,4][0-9]{8}$/, message: "Please provide a valid Phone number", trigger: ["change", "blur"] }
        ],
      },
    };
  },
  mounted() {
    document.documentElement.scrollTop = 0;
    this.getOrdersIntentionDown();
  },
  methods: {
    getOrdersIntentionDown() {
      get(OrdersIntentionDown).then(res => { if (res.data.code === 200) this.options = res.data.data; });
    },
    geolocate() { this.$refs.child?.geolocate(); },
    getinfo(data) {
      if (data.tag === "placepc" || data.tag === "placeh5") {
        this.form.Address = data.address || "";
        this.form.Suburb = data.locality || "";
        this.form.Postcode = data.postal_code || "";
        this.form.streetName = data.route === "long_name" ? "" : data.route || "";
        this.form.Street_number = data.street_number === "short_name" ? "" : data.street_number || "";
        this.form.City = data.administrative_area_level_2 === "short_name" ? "" : data.administrative_area_level_2 || "";
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.isSubmitting = true;
        let IntentionName = "";
        if (this.form.EnquiryType) {
          const found = this.options.find(item => item.Id == this.form.EnquiryType);
          if (found) IntentionName = found.Name;
        }
        const leadsfrom = this.$route.query.leadsfrom || "batteryplant";
        const formdata = {
          FirstName: this.form.FirstName, LastName: this.form.LastName, Address: this.form.Address,
          PhoneNumber: this.form.Phone, Email: this.form.Email, Intention: this.form.EnquiryType,
          IntentionName, Message: this.form.InterestedGroup, leadsfrom,
        };
        post(ContactUsSubmit, formdata).then(res => {
          if (res.data.code === 200) { this.form = {}; this.$message.success("Successful."); }
          else { this.$message.error(res.data.msg); }
          this.isSubmitting = false;
        }).catch(() => {
          this.$message.error("Submission failed. Please try again.");
          this.isSubmitting = false;
        });
      });
    },
    goto(name) {
      const routes = { HOME: "/index", PROJECT: "/Project", PRODUCTS: "/Productslist", CASE: "/Case", CONTACTUS: "/ContactUs" };
      if (routes[name]) {
        sessionStorage.setItem("activeIndexh5", routes[name]);
        if (name !== "CONTACTUS") this.$router.push(routes[name]);
        else document.documentElement.scrollTop = 0;
      }
    },
  },
};
</script>

<style scoped>
/* ========== PC端样式 ========== */
.pc-container {
  width: 100%;
  min-width: 1349px;
  margin-top: 65px;
  background: white;
  overflow: hidden;
}

/* Banner */
.banner-wrapper {
  position: relative;
}
.banner-img {
  width: 100%;
}
.banner-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 48px;
  text-align: center;
  width: 100%;
}

/* 联系方式卡片 */
.contact-cards {
  position: absolute;
  top: 120%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: 85%;
  max-width: 1400px;
  gap: 2.5%;
  z-index: 10;
}
.contact-card {
  flex: 1;
  background: white;
  border-radius: 12px;
  padding: 20px 15px;
  box-shadow: 4px 4px 12px rgba(0,0,0,0.1);
  border: 1px solid #e0e0e0;
}
.card-icon img {
  width: 20px;
  height: 20px;
}
.card-label {
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0 5px;
}
.card-value {
  font-size: 12px;
  word-break: break-word;
}

/* 表单区域 */
.form-wrapper {
  margin-top: 200px;
  text-align: center;
}
.form-header {
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
}
.form-subtitle {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}
.form-container {
  max-width: 65%;
  margin: 30px auto;
  background: rgba(255,255,255,0.91);
  border-radius: 12px;
  padding: 30px;
  box-shadow: 4px 4px 12px rgba(0,0,0,0.1);
}
.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}
.form-item-half {
  flex: 1;
}
.form-item-full {
  width: 100%;
}
::v-deep .el-form-item__label {
  text-align: left !important;
  font-weight: normal;
}
::v-deep .el-input__inner {
  border-radius: 10px;
  background: #f3f3f3;
  border: 1px solid #f3f3f3;
  padding: 12px 20px;
}
::v-deep .el-select { width: 100%; }
.form-submit {
  text-align: center;
  margin-top: 30px;
}
.submit-btn {
  background: linear-gradient(to right, #007bff, #28a745);
  padding: 12px 50px;
  border-radius: 50px;
  color: white;
  font-weight: bold;
  border: none;
  cursor: pointer;
}

/* FAQ */
.faq-wrapper {
  max-width: 65%;
  margin: 0 auto;
  padding: 40px 0;
  text-align: left;
}
.faq-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}
.faq-question {
  font-weight: bold;
  margin: 20px 0 8px;
}
.faq-answer {
  font-size: 14px;
  color: #666;
}

/* 底部导航 */
.footer {
  padding: 20px 40px;
  background: white;
}
.footer-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-logo img {
  height: 28px;
}
.footer-nav {
  display: flex;
  gap: 30px;
}
.footer-nav span {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
}
.footer-nav span:hover { color: #0c80da; }
.footer-divider {
  height: 1px;
  background: #ccc;
  margin: 15px 0 18px;
}
.footer-contact {
  text-align: right;
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}

/* ========== 移动端样式 ========== */
.mobile-container {
  width: 100%;
  background: white;
  overflow: hidden;
}
.mobile-banner {
  position: relative;
}
.mobile-banner-img {
  width: 100%;
}
.mobile-banner-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 28px;
  text-align: center;
  width: 100%;
}
.mobile-contact-cards {
  position: absolute;
  top: 8%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 85%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mobile-contact-card {
  background: white;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 4px 4px 12px rgba(0,0,0,0.1);
  border: 1px solid #e0e0e0;
}
.mobile-contact-card img {
  width: 24px;
  height: 24px;
}
.mobile-contact-card .card-label {
  font-size: 16px;
  margin: 8px 0 4px;
}
.mobile-contact-card .card-value {
  font-size: 12px;
}
.mobile-form-wrapper {
  margin-top: 280px;
  padding: 0 15px;
  text-align: center;
}
.mobile-form-header {
  font-size: 20px;
  font-weight: bold;
  color: #2c3e50;
}
.mobile-form-subtitle {
  font-size: 12px;
  color: #666;
  margin: 10px 0 20px;
}
.mobile-form-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 4px 4px 12px rgba(0,0,0,0.1);
}
::v-deep .mobile-form-container .el-form-item {
  margin-bottom: 15px;
}
::v-deep .mobile-form-container .el-input__inner {
  border-radius: 10px;
  background: #f3f3f3;
  border: none;
  padding: 12px;
}
::v-deep .mobile-form-container .el-select {
  width: 100%;
}
.mobile-submit {
  text-align: center;
  margin-top: 20px;
}
.mobile-submit .submit-btn {
  width: 60%;
  padding: 10px;
}
.mobile-faq-wrapper {
  padding: 30px 20px;
  text-align: left;
}
.mobile-faq-wrapper .faq-title {
  font-size: 20px;
}
.mobile-faq-wrapper .faq-question {
  font-size: 14px;
}
.mobile-faq-wrapper .faq-answer {
  font-size: 13px;
}
.mobile-footer {
  padding: 20px;
  background: white;
  text-align: center;
}
.mobile-footer-logo img {
  height: 28px;
}
.mobile-footer-nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin: 15px 0;
}
.mobile-footer-nav span {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
}
.mobile-footer-contact {
  font-size: 12px;
  color: #666;
  line-height: 1.8;
  margin-top: 10px;
}
.footer-divider {
  height: 1px;
  background: #ccc;
  margin: 10px 0;
}

/* 响应式 */
@media (max-width: 1200px) {
  .contact-cards { width: 90%; }
  .form-container { max-width: 80%; }
  .faq-wrapper { max-width: 80%; }
}
@media (max-width: 768px) {
  .pc-container { display: none; }
  .contact-cards { top: 10%; width: 90%; }
}
@media (min-width: 769px) {
  .mobile-container { display: none; }
}
</style>